import React from 'react';

import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

import style from 'style';
import unitingLogo from 'assets/partners/uniting-logo.png';
import aaaLogo from 'assets/partners/aaa.svg';
import hicapsLogo from 'assets/partners/hicaps.svg';
import youFirstLogo from 'assets/partners/you-first-logo.png';
import jpmLogo from 'assets/partners/jpm-logo.svg';
import facLogo from 'assets/partners/fac-logo.png';
import mypLogo from 'assets/partners/myp.svg';
import instacareLogo from 'assets/partners/instacare-logo.png';


const MAX_LOGOS_PER_ROW = 6;
const LOGO_COL_GAP = '30px';


const PARTNER_LOGOS = [
  {
    logo: youFirstLogo,
    width: '110px',
    onClick: () => window.open('https://www.youfirstservices.com.au', '_blank'),
  },
  {
    logo: unitingLogo,
    height: '40px',
    onClick: () => window.open('https://www.uniting.org/services/disability-services', '_blank'),
  },
  {
    logo: aaaLogo,
  },
  {
    logo: hicapsLogo,
    width: '145px',
  },
  {
    logo: mypLogo,
    height: '30px',
  },
  {
    logo: facLogo,
    width: '150px',
    onClick: () => window.open('https://www.findacarer.com.au/', '_blank'),
  },
  {
    logo: jpmLogo,
    onClick: () => window.open('https://justplanmanagers.com.au', '_blank'),
  },
  {
    logo: instacareLogo,
    height: '45px',
    onClick: () => window.open('https://www.instacare.com.au', '_blank'),
  },
];


const Container = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

const InnerContainer = styled.div`
  max-width: 1280px;
  width: 100%;
  padding: 25px;
  
  .text {
    text-align: center;
    color: ${style.colors.palette.battleshipGrey};
    font-size: 16px;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 30px ${LOGO_COL_GAP};
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 20px;
  
  img {
    flex: 0 0 calc((100% - ${MAX_LOGOS_PER_ROW} * ${LOGO_COL_GAP}) / ${MAX_LOGOS_PER_ROW + 1});
    object-fit: contain;
  }
`;

const Partners = () => {

  const history = useHistory();

  return (
    <Container>
      <InnerContainer>
        <div className="text">
          Proudly partnered with
        </div>
        <LogoContainer>
          {PARTNER_LOGOS.map((item, idx) => (
            <img
              key={idx}
              height={item.height ? item.height : '50px'}
              width={item.width && item.width}
              src={item.logo}
              alt="Clickability Partner"
              onClick={() => item.onClick ? item.onClick() : history.push('/about#partners')}
              style={{cursor: 'pointer'}}
            />
          ))}
        </LogoContainer>
      </InnerContainer>
    </Container>
  );
};


export default Partners;

